import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { fetchAuthSession } from "@/lib/fetchAuthSession";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<"loading" | "ok" | "no">("loading");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    void fetchAuthSession()
      .then((r) => {
        if (cancelled) return;
        if (r.ok) setState("ok");
        else setState("no");
      })
      .catch(() => {
        if (!cancelled) setState("no");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "loading") {
    return (
      <div className="bg-bg flex min-h-screen items-center justify-center">
        <p className="text-zinc-500">Loading…</p>
      </div>
    );
  }

  if (state === "no") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
